import { ReactElement, useCallback } from 'react';
import { DialogContentText, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { PATHS } from '~constants/paths';
import { getStringifyUrlQueryString } from '~utils/router';

import { DialogGlobalAlertProps } from './types';
import {
  DialogGlobalAlertContainer,
  DialogGlobalAlertHeader,
  DialogGlobalAlertContent,
  DialogGlobalAlertActions,
} from './styles';

const DialogGlobalAlert = ({
  open,
  onClose,
  title,
  descriptions,
}: DialogGlobalAlertProps): ReactElement => {
  const navigate = useNavigate();

  const handleRedirectPlansPackages = useCallback(() => {
    const url = getStringifyUrlQueryString({
      url: PATHS.CONFIG.SUBSCRIPTIONS.BASE,
      query: {
        currentTab: 'plans-packages',
      },
    });

    navigate(url);

    onClose();
  }, [navigate, onClose]);

  return (
    <DialogGlobalAlertContainer open={open} maxWidth={false}>
      <DialogGlobalAlertHeader>
        <Typography
          variant="body1"
          component="h2"
          fontWeight="bold"
          color="inherit"
        >
          {title}
        </Typography>
      </DialogGlobalAlertHeader>

      <DialogGlobalAlertContent dividers>
        {descriptions.map((description, descriptionIndex) => (
          <DialogContentText
            key={`dialog-global-alert-description-${descriptionIndex}`}
            color="text.primary"
            variant="body2"
          >
            {description}
          </DialogContentText>
        ))}
      </DialogGlobalAlertContent>

      <DialogGlobalAlertActions>
        <Button color="primary" onClick={handleRedirectPlansPackages}>
          Ver Planes
        </Button>

        <Button color="secondary" onClick={onClose}>
          Cerrar
        </Button>
      </DialogGlobalAlertActions>
    </DialogGlobalAlertContainer>
  );
};

export default DialogGlobalAlert;
